import {useDealFreezeOfferBoxContext} from './DealFreezeOfferBoxContext'

// Offer id, not position: split bookings shift positions but keep ids
export const useIsFreezableTopOffer = (offerId?: string): boolean => {
  const state = useDealFreezeOfferBoxContext()

  return Boolean(offerId) && state?.freezableTopOfferId === offerId
}
